<mat-form-field [floatLabel]="floatLabel" [hideRequiredMarker]="hideRequiredMarker" [class]="cssClass" [ngClass]="{
  'custom-vertical-chip-list': verticalChipList,
  'form-field-virtual-scrollable': verticalChipList && selectedOptions.length > VIRTUAL_SCROLL_THRESHOLD,
  'form-field-normal-scroll': !verticalChipList
}">
  <mat-label *ngIf="label">
    <span>{{ label }}</span>
    @if (showRequiredStatusInLabel) {
    <span *ngIf="required">({{ 'required' | translate }})</span>
    <span *ngIf="!required">({{ 'optional' | translate }})</span>
    }
  </mat-label>
  <ng-container *ngIf="verticalChipList && selectedOptions.length > VIRTUAL_SCROLL_THRESHOLD; else normalScroll">
    <mat-chip-grid #chipGrid [formControl]="formCtrl" [required]="required" (click)="onInputFocus()">
      <cdk-virtual-scroll-viewport id="{{inputId}}ChipGrid" itemSize="32" class="scroll-viewport">
        @if (avatarChipTheme) {
        <mat-chip-row class="email-chip" *cdkVirtualFor="let option of selectedOptions" [removable]="removable"
          (removed)="remove(option)">
          <div class="d-flex align-items-center">
            <small class="user-profile__avatar" [style.background-color]="option['avatarBackgroundColor']">
              {{ option['userInitals'] }}
            </small>
            <small class="margin-end-s">
              {{ option[textProperty] }}
            </small>
          </div>
          <button matChipRemove *ngIf="removable">
            <icon name="close" svgFill="var(--m3-sys-on-surface)"></icon>
          </button>
        </mat-chip-row>
        }
        @else {
        <mat-chip-row [color]="chipColor" *cdkVirtualFor="let option of selectedOptions" [removable]="removable"
          (removed)="remove(option)">
          <span class="chip-text">{{option[textProperty]}}</span>
          <button matChipRemove *ngIf="removable">
            <icon name="close" width="16" height="16"></icon>
          </button>
        </mat-chip-row>
        }
      </cdk-virtual-scroll-viewport>

      <input #chipInput [id]="inputId" placeholder="{{placeHolder}}" [formControl]="autoCompleteControl"
        [matAutocomplete]="auto" [matChipInputFor]="chipGrid" (matChipInputTokenEnd)="add($event)" />
      <div matSuffix class="d-flex">
        <icon name="info" matTooltip="{{ infoText }}" matTooltipPosition="above" *ngIf="infoText">
        </icon>
        <mat-spinner id="spinner_autoComplete" diameter="25" *ngIf="selectedOptionsLoading"></mat-spinner>
      </div>
    </mat-chip-grid>
  </ng-container>
  <ng-template #normalScroll>
    <mat-chip-grid #chipGrid id="{{inputId}}ChipGrid" [formControl]="formCtrl" [required]="required"
      (click)="onInputFocus()">
      @if (avatarChipTheme) {
      <mat-chip-row class="email-chip" *ngFor="let option of selectedOptions" [removable]="removable"
        (removed)="remove(option)">
        <div class="d-flex align-items-center">
          <small class="user-profile__avatar" [style.background-color]="option['avatarBackgroundColor']">
            {{ option['userInitals'] }}
          </small>
          <small class="margin-end-s">
            {{ option[textProperty] }}
          </small>
        </div>
        <button matChipRemove *ngIf="removable">
          <icon name="close" svgFill="var(--m3-sys-on-surface)"></icon>
        </button>
      </mat-chip-row>
      }
      @else {
      <mat-chip-row [color]="chipColor" *ngFor="let option of selectedOptions" [removable]="removable"
        (removed)="remove(option)">
        <span class="chip-text">{{option[textProperty]}}</span>
        <button matChipRemove *ngIf="removable">
          <icon name="close" width="16" height="16"></icon>
        </button>
      </mat-chip-row>
      }
      <input #chipInput [id]="inputId" placeholder="{{placeHolder}}" [formControl]="autoCompleteControl"
        [matAutocomplete]="auto" [matChipInputFor]="chipGrid" (matChipInputTokenEnd)="add($event)" />
      <div matSuffix class="d-flex">
        <icon name="info" matTooltip="{{ infoText }}" matTooltipPosition="above" *ngIf="infoText">
        </icon>
        <mat-spinner id="spinner_autoComplete" diameter="25" *ngIf="selectedOptionsLoading"></mat-spinner>
      </div>
    </mat-chip-grid>
  </ng-template>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event.option.value)">
    <mat-option class="list-item" *ngFor="let option of filteredOptions | async" [value]="option"
      [class.mdc-list-item--selected]="false">
      {{option[textProperty]}}
    </mat-option>
  </mat-autocomplete>
  <mat-hint id="input_hint" class="text-gray" *ngIf="hint">{{hint}}</mat-hint>
  <mat-error [id]="matErrorId" *ngIf="formSubmitted && required && requiredText && formCtrl.errors?.['required']">
    {{ requiredText }}
  </mat-error>
</mat-form-field>